import Api from "./api";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import {getCookie} from './utils';
const {
  EXCLUDED_PM_ENTITYID_FOR_CHATBOT,
  KEY_CHAIN,
} = require("../constants.js");

export default function ChatBot(props) {
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get("accessToken");
  let userPMEntityId = props?.userDetails?.pmEntityID;

  const [hasScript, setHasScript] = useState(false);
  const [appToken, setAppToken] = useState("");
  const [isChatbotPresent, setIsChatbotPresent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const getOs = () => {
    try {
      if (typeof window !== "undefined") {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (/windows nt/.test(userAgent)) {
          return "Windows";
        } else if (/android/.test(userAgent)) {
          return "Android";
        } else if (/iphone|ipod|ipad/.test(userAgent)) {
          return "iOS";
        } else if (/mac os/.test(userAgent)) {
          return "MacOS";
        } else if (/linux/.test(userAgent)) {
          return "Linux";
        } else {
          return "Unknown";
        }
      } else {
        return "Server";
      }
    } catch (error) {
      console.error(error);
    }
  };
  const osType = getOs();
  const handleToken = async () => {
    try {
      const payload = {
        clientId: KEY_CHAIN.FRESHCHAT_CLIENT_ID,
        mbShortToken: props.shortToken,
      };
      const response = await Api.getAppToken(payload);

      setAppToken(response?.accessToken);

      if (
        userPMEntityId &&
        !Object.values(EXCLUDED_PM_ENTITYID_FOR_CHATBOT).includes(
          userPMEntityId
        )
      ) {
        setHasScript(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const chatbotQueryParam = urlParams.get("chatbot");
    const chatbotPath = window.location.pathname.includes("/chatbot");
    setIsChatbotPresent(chatbotQueryParam !== null || chatbotPath);
  }, []);

  useEffect(() => {
    handleToken();
  }, []);
  useEffect(() => {
    if (hasScript && appToken && osType && isChatbotPresent) {
      const script = document.createElement("script");
      script.src = "//in.fw-cdn.com/31749060/896280.js";
      script.setAttribute("widgetId", "1934f439-59aa-401e-a583-a3e838ab4329");
      script.setAttribute("chat", "true");
      document.head.appendChild(script);
      script.onload = () => {
        window.fwcrm.on("widget:loaded", () => {
          const appVersion = getCookie("versionCode");
          const platform = getCookie("platform");
          window.fcWidget.conversation.setBotVariables({
            browserType: osType,
            userAppToken: appToken,
            versionCode: appVersion,
            platform: platform,
          });

          window.fcWidget.open();
          setIsLoading(false);
        });
      };
      window.fcWidgetMessengerConfig = {
        jsFunctions: {
          redirectToNativeView: (Deeplink) => {
            let androidDeeplink = Deeplink.androidDeeplink.trim();
            let iosDeeplink = Deeplink.iosDeeplink.trim();
            let webDeeplink = Deeplink.webDeeplink.trim();
            let browserType = Deeplink.browserType.trim();
            try {
              switch (browserType) {
                case "AndroidWebView":
                  window.WebToNativeCommunicationInterface.openDeeplink(
                    androidDeeplink
                  );
                  break;
                case "IOSWebView":
                  window.webkit.messageHandlers.deepLinkUrl.postMessage(
                    iosDeeplink
                  );
                  break;
                case "ChromeWeb":
                case "SafariWeb":
                  if (window.location !== window.parent.location) {
                    window.parent.postMessage({ openLink: webDeeplink }, "*");
                  } else {
                    window.open(webDeeplink, "_blank");
                  }
                  break;
                default:
                  console.log(
                    browserType + " : no deeplink implementation found"
                  );
                  break;
              }
            } catch (error) {
              console.log(error);
              window.open(webDeeplink, "_blank");
            }
          },

          redirectToDialler: (data) => {
            window.location.href = `tel:${data.phoneNumber}`;
          },
        },
      };
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [hasScript, appToken, osType, isChatbotPresent]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  return null;
}
